import React, { useState } from "react";
import { useParams } from "react-router-dom";
//import { Identity } from "../../../../components/Identity";
import { PageTopbar } from "../../../../components/Page/Topbar";
import { PageHeader } from "../../../../components/Page/Header";
import { AppArticlesProductActionsRepair } from "../../../../app/Articles/Product/Actions/Repair";
import { getPageTitle } from "../../../../app/helpers/global";

export function RoutesArticlesProductActionsRepair({ parents, current }) {

    let identifier = (parents+current).replaceAll('/', '-');
    let group = parents.indexOf('articles/depot')===-1 ? 'location' : 'depot';

    const { productId } = useParams();
    const [ title, setTitle] = useState(null);

    if (title === null) {
        getPageTitle('product', productId, setTitle);
    }

    return (
        <div>
            
            <PageTopbar
                parents={parents}
                current={current}
            />
            
            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                tabGroup={"product-details-" + group}
                variables={{productId:productId}}
                identifier={identifier}
            />

            <AppArticlesProductActionsRepair
                parents={parents}
                redirectUri={ "/" + parents.replace("actions", "details/") + productId }
                cancelUri={ "/" + parents + "/" + productId }
                requestType="REPAIR-DEPOT"
                sourceId={productId}
                identifier={identifier}
            />
        </div>
    );
}